import * as React from "react";
// import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import Layout from "../components/Layout";
import Seo from "../components/Seo";

const MerchPage = () => {
	return (
		<Layout>
			<Seo title="Now" />
			<h2>Now</h2>
			<div className="main--centerwrapper">
				<StaticImage
					src="../images/photos/pressRes/Jesse_Rivest_Toadstool_007.jpg"
					alt="Jesse Rivest press image"
					placeholder="blurred"
					layout="constrained"
					className="main--centered"
					imgClassName="img--bordered-small"
					width={500}
				/>
			</div>

			<h3>What am I doing now?</h3>
			<p>
				Update October 9, 2025, from a very hot and dry Brasilia.<br />
				(This is a <span className="italic">now page</span> in the style of Derek Sivers.)
			</p>

			<h4>Live-streaming practice sessions</h4>
			<p>
				My Wednesday night practice sessions on YouTube continue.
				The obvious alternative to YouTube would be to have a residency or regular places to play at in Brasilia (where I have mostly been basing myself these days);
				that's not simple due to cultural differences between Brazil and where I'm from.
				I of course still value keeping my repertoire alive and somewhat ready for some future show or opportunity.
			</p>

			<h4>Working</h4>
			<p>
				I haven't looked for software engineering work at all since January 2025.
				However, I've kept fairly busy providing music services since then.
				I would like to attain the <span className="bold">Top Seller</span> badge on AirGigs for more visibility on the platform;
				I think I'm more than halfway there.
				Wanna hire me?
				It will help me!
				I'm also available outside of that platform; just contact me.
			</p>
			<p>
				I've been mixing the shit out of my own version of Ryan Mack's song, <span className="italic">Dive In</span>.
				It's almost crazy how much time I've put into this track, from production earlier this year to mixing in the past month or two.
				It's not a song I would normally go for—I was hired on AirGigs to make a more folky version of this song.
				Along the way, I realized I could release my version;
				with that came a desire to mix the song in a more modern, aggressive way than I usually treat my own music.
				Then, listening to the agressive mix (achieved!), I found it too aggressive.
				Now, I'm thinking of making a softer mix and releasing both.
				I'm thinking of releasing these via a side project/profile rather than my own/usual artist profile.
			</p>
			<p>
				I've also been producing a song with my good friend, Murilo, who has played bass on some of my releases over the years and played some shows with me in Brasilia.
				Since I'm singing on the song and the lyrics are mine, I need to be a/the primary artist on the release, but the song really doesn't fit in with my usual catalogue.
				Again, I'm thinking of releasing via that side project/profile I just mentioned.
			</p>
			<p>
				I've also come up with my own version—using tremolo electric guitar—of Joni Mitchell's <span className="italic">Both Sides Now</span>.
				Recording it hasn't been on my mind but it is entering my repertoire;
				I've loved this song since I was a little kid.
			</p>
			<p>
				Oh, in case you've seen my past words about being rendered without an audio interface in my studio—thanks
				Apple and Focusrite—I have now acquired an RME Babyface Pro FS to connect all my mics, preamps, and my monitors to my Macbook.
				I am very happy with it!
			</p>

			<h4>Patreon is not social media</h4>
			<p>
				I'm trying to make a Patreon post (video) every week but it ends up sometimes one every two weeks.
				I don't want to make "content" for the sake of a platform, so I need to feel that I'm working on an aspect of my music that I then choose to document with a small video.
				I don't want anything behind a paywall and I have less than 10 subscribers.
				I thought this all through either earlier this year or sometime last year and Patreon is the most appropriate place for someone like me to share what I am sharing.
				(In other words, I have zero interest in or time for trying to game the algorithms of the big social media platforms.)
			</p>

			<h4>Reading</h4>
			<p>
				I've been struggling all year to get through (reading) <span className="italic">The Precipice</span>, by Toby Ord.
				I have in parallel just started reading <span className="italic">Why We (Still) Need Record Labels: The New Era of Indie Record Labels and Why They Still Matter</span>, by Scott Orr.
				The latter will be much easier and faster to read 😅.
			</p>

			<h4>Watching</h4>
			<p>
				I've seen a lot of movies this year and just recently enjoyed <span className="italic">One Battle After Another</span>, by Paul Thomas Anderson,
				as well as <span className="italic">Three Colours: Blue</span> and <span className="italic">Three Colours: Red</span>, by Krzysztof Kieślowski.
				I'll of course next watch the last remaining, <span className="italic">White</span>, of the trilogy.
			</p>

			<h4>Listening</h4>
			<p>
				I listen to plenty of music and this week am focusing on the new <span className="italic">Incurable Optimist</span>, by Hohnen Ford.
				I may still be analyzing the production and sound this week of <span className="italic">Better Broken</span>, by Sarah McLachlan.
				And I may close my eyes and hear yet again <span className="italic">That Wasn't a Dream</span>, by Pino Palladino and Blake Mills.
			</p>


		</Layout>
	);
}

export default MerchPage;
